<template>
  <div role="group" class="b-form-group form-group">
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('FIRSTNAME')">
          <inputvalidation :formerror="formError" name="first_name">
            <b-form-input type="text" v-model="formData.first_name"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('LASTNAME')">
          <inputvalidation :formerror="formError" name="last_name">
            <b-form-input type="text" v-model="formData.last_name"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('DATEOFBIRTH')">
          <inputvalidation :formerror="formError" name="date_of_birth">
            <b-form-input type="date" v-model="formData.date_of_birth"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('PHONENUMBER')">
          <inputvalidation :formerror="formError" name="phone_number">
            <b-form-input type="text" v-model="formData.phone_number"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('THERAPYTYPE')">
          <inputvalidation :formerror="formError" name="therapy_id">
              <lb-vue-select v-model= "formData.therapy_id"
                              :list= "therapyTypes.root"
                              display-field= "name"
                              value-field= "therapyTypeId"
                              :items-placeholder= "$t('THERAPYTYPE')">
                </lb-vue-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('CONTACTDATE')">
          <inputvalidation :formerror="formError" name="contact_date">
            <b-form-input type="date" v-model="formData.contact_date"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('NOTES')">
          <inputvalidation :formerror="formError" name="notes">
            <b-form-textarea v-model="formData.notes" rows="4"></b-form-textarea>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'WaitlistIndividualSessionsForm',
    props: ['formData', 'formError', 'therapyTypes'],
};
</script>
